module.exports = "<app-files-list [showDelete]=\"true\"></app-files-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/files-admin/files-admin.component.html
// module id = ./src/app/views/files-admin/files-admin.component.html
// module chunks = main